<template>
  <component :is="tag" :to="href" exact> {{ name }} </component>
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    name: {
      type: String
    },
    href: {
      type: String,
      required: true
    }
  },
  computed: {
    tag() {
      return this.href ? 'nuxt-link' : 'a'
    }
  }
}
</script>



// WEBPACK FOOTER //
// components/_UI/BaseLink.vue